export default __webpack_public_path__ + "static/media/sponsor_300x250.8534a138.jpg";